import api from '@/services/api'

export default class EvaluationResponseAPI {
  static EVALUATION_RESPONSE_ENDPOINT = 'evaluation-responses'
  /**
   * Initialize a `EvaluationResponseAPI` instance.
   *
   * @param {class} cls  The class to use to create evaluationResponse objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `EvaluationResponseAPI`.
   *
   * @param {class} cls      The class to use to create evaluationResponse objects.
   **/
  static create(cls) {
    return new EvaluationResponseAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one evaluationResponse from the API.
   *
   * @param {String} evaluationResponseId  Unique ID of the evaluation to retrieve.
   */
  get(evaluationResponseId) {
    const url = `${EvaluationResponseAPI.EVALUATION_RESPONSE_ENDPOINT}/${evaluationResponseId}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Get all evaluationResponse through the API.
   *
   *
   */
  // eslint-disable-next-line no-unused-vars
  list({ filters = {} } = {}) {
    const url = `${EvaluationResponseAPI.EVALUATION_RESPONSE_ENDPOINT}/`
    const options = {
      params: {},
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => {
        // To Do, add data.results instead of data when you add pagination
        data.results = data.results.map(this.cls.fromAPI)
        return data
      })
  }

  /**
   * Update a evaluationResponse through the API.
   *
   * @param {evaluationResponse} evaluationResponse data to send to the API.
   */
  update(evaluationResponse, fields = [], excludeFields = []) {
    const url = `${EvaluationResponseAPI.EVALUATION_RESPONSE_ENDPOINT}/${evaluationResponse.id}/`
    const data = this.cls.toAPI(evaluationResponse, fields, excludeFields)
    // NA Problem - Update
    return this.client.patch(url, data).then(response => this.cls.fromAPI(response.data))
  }
}
